import React from "react";
import { P } from "../Texts";
import { DarkFormFieldStyle, DarkFormInput, FormFieldHolder } from "./input.styles";

export const DarkFormField = React.forwardRef(
  (
    {
      className,
      containerClass,
      data_testid,
      icon,
      iconClick,
      iconBefore,
      iconBeforeClass,
      iconBeforeClick,
      id,
      inputClassName,
      label,
      name,
      required,
      placeholder,
      type,
      disabled,
      marginBottom,
      onChange,
      ...rest // Spread operator to catch other props from register
    },
    ref,
  ) => {
    return (
      <FormFieldHolder
        marginBottom={marginBottom}
        className={`${containerClass ? containerClass : ""}`}
      >
        {label && (
          <label className="block" htmlFor={id}>
            <P
              fontSize="14px"
              fontFamily="semi"
              color="#47495C"
              className="mb-2 flex items-center justify-between"
            >
              {label}
              {required && (
                <span className="" style={{ color: "#E62250" }}>
                  *{" "}
                  <span
                    style={{ color: "#22202D" }}
                    className="text-xs font-normal "
                  >
                    Required
                  </span>
                </span>
              )}
            </P>
          </label>
        )}

        <DarkFormFieldStyle className={className}>
          {iconBefore && (
            <div
              className="h-full flex-shrink-0 py-2 px-4"
              onClick={iconBeforeClick}
            >
              <img src={iconBefore} alt="" className={iconBeforeClass} />
            </div>
          )}

          <DarkFormInput
            type={type}
            ref={ref}
            id={id}
            name={name}
            className={`flex-grow ${inputClassName && inputClassName}`}
            placeholder={placeholder}
            data-testid={data_testid}
            disabled={disabled}
            onChange={onChange}
            {...rest} // Spread the remaining props from register
          />
          {icon && (
            <div
              className="h-full flex-shrink-0 py-2 px-4 cursor-pointer"
              onClick={iconClick}
            >
              <img src={icon} alt="" />
            </div>
          )}
        </DarkFormFieldStyle>
      </FormFieldHolder>
    );
  },
);
